<template>
  <div class="upThumb rd3">
    <div class="wrap">
      <el-upload class="avatar-uploader" :action="action" :headers="{ token: token }" name="file"
        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <template v-if="imgUrl">
          <el-image :src="imgUrl" style="width: 100px; height: 100px;" class="avatar" fit="cover" />
        </template>
        <div v-else class="upDef">
          <div class="inner">
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <p>
              <slot name="title"></slot>
            </p>
          </div>
        </div>
        <div v-if="imgUrl" class="look">
          <span class="look-sp" @click.stop="handlePreview()">
            查看
            <el-image :style="styleCss" :src="imgUrl"  :preview-src-list="[imgUrl]" fit="cover"></el-image>
          </span>
          <span class="look-line"></span>
          <span class="look-sp look-edit">修改</span>
        </div>
      </el-upload>
      
    </div>
    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500KB，宽高120*154</div>
  </div>
</template>

<script>
  // import { api, uploadApi } from '@/http/api'
  import {
    upUrlApi
  } from '@/http/api.js'
  export default {
    props: {
      revImgurl: String
    },
    data() {
      return {
        action: upUrlApi,
        token: '',
        imgUrl: '',
        styleCss:"position: absolute; left: 0; bottom: 0; width: 100%; height:100%;z-index:30; opacity:0"
      }
    },
    mounted() {
      this.token = localStorage.getItem('token');
      this.imgUrl = this.revImgurl;
    },
    methods: {
      handlePreview(){
        console.log('查看')
      },
      // 上传缩略图
      handleAvatarSuccess(res, file) {
        console.log('单图', file)
        this.imgUrl = file.response.data.url;
        this.$emit('ok', this.imgUrl)
      },
      beforeAvatarUpload(file) {
        console.log('file--', file)
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 0.5;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 jpg、jpeg、png 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 500kb!');
        }
        // 创建 FileReader 对象
        let imgWH = true
        const reader = new FileReader();
        reader.readAsDataURL(file); // 将文件读取为 DataURL
  
        // 当文件加载完成后执行
        reader.onload = (e) => {
          // 创建 Image 对象
          const image = new Image();
          image.src = e.target.result; // 设置图片源为读取到的 DataURL
  
          // 图片加载完成后获取宽高
          image.onload = () => {
            this.imageWidth = image.width;
            this.imageHeight = image.height;
            console.log('图片宽度:', this.imageWidth);
            console.log('图片高度:', this.imageHeight);
  
            // 可以在这里进行宽高的验证或处理
            if (this.imageWidth !== 120 || this.imageHeight != 154) {
              imgWH = false
              return this.$message.error('图片尺寸不对，请按照要求上传图片');
            }else{
              imgWH = true
            }
            
          };
        }
        return isJPG && isLt2M && imgWH;
      },
      deleteImg() {
        console.log('1')
        this.imgUrl = '';
        this.$emit('ok', this.imgUrl)
      }
    },
  }
</script>

<style scoped>
  .upThumb {
    
    .wrap{
      width: 100px;
      height: 100px;
      border: 1px dashed #DCDFE6;
    }
  }
  .wrap{position: relative;}
  .look-sp{position: relative; width:40%; font-size: 12px; line-height: 1; padding: 4px 0;}
  .look{position: absolute; left: 0; bottom: 0; width: 100%; background-color: rgba(0, 0, 0, 0.5); color: #fff; text-align:center;  display:flex; align-items:center; justify-content:center}
  .look-line{width:1px; height:16px; background-color:#fff; padding:0; margin:0 6px;}
  
  .upThumb .avatar-uploader {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    justify-content: center;
    position: relative;
  }

  .closeBtn {
    color: #f00;
    position: absolute;
    right: -8px;
    top: -8px;
    width: 20px;
    cursor: pointer;
  }

  .upThumb .upDef {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    text-align: center;
  }

  .upThumb .upDef .inner {
    line-height: 1;
  }

  .upThumb .upDef .avatar-uploader-icon {
    color: #C0C4CC;
    font-size: 20px;
  }

  .upThumb .upDef p {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
  }

  .upThumb /deep/ .el-upload {
    width: 100%;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
  }

  .upThumb .avatar {
    width: 100%;
    object-fit: cover;
    height: 78px;
    display: block;
    border-radius: 3px;
  }
</style>